<div class="video-container">
    <iframe [src]="context.url | safeResource"
            frameborder="0" allowfullscreen></iframe>
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/video/video.component.html